import { NgModule } from '@angular/core';
import { SharedModule } from '../shared';
import { UserModule } from '../user';
import { CovanceAgGridModule } from '../covance-ag-grid/covance-ag-grid.module';
import { GroupingModule } from '../grouping-selector';
import { CovanceFilterModule } from '../covance-filter';
import { LegendModule } from '../legend';
import { EQueryFilterDefinitions } from './e-query-filter-definitions';
import { ExternalUserEQueriesGridComponent } from './external-user-e-queries-grid/external-user-e-queries-grid.component';
import { CommonModule } from '@angular/common';
import { SimpleTextFieldModule } from '../simple-text-field/simple-text-field.module';
import { EQueriesColumns } from './e-queries-columns';
import { ReadEQueryEmitter } from './read-e-query-emitter';
import { ExternalUserEQueriesColumns } from './e-queries-columns/external-user-e-queries-columns';
import {ExternalUserEQueriesFilterDefinitions} from './external-user-e-query-filter-definitions';
import { ExternalUserEQueriesGridDefaultSort } from './external-user-e-queries-grid-default-sort';
import {EQueriesFreeTextQuestionComponent} from './e-query-details/e-queries-free-text-question-input/e-queries-free-text-question.component';
import {ReactiveFormsModule} from '@angular/forms';
import {CovanceDatePickerModule} from '../covance-date-picker/covance-date-picker.module';
import {EQueryAccessionInfoComponent} from './accession-info/e-query-accession-info.component';
import {EQueryAttachmentsComponent} from './e-query-details/attachments/e-query-attachments.component';
import {EQueryDetailsTextFieldComponent} from './e-query-details/e-query-details-text-field/e-query-details-text-field.component';
import {EQueryAttachmentsDownloader} from './e-query-details/e-query-attachments-downloader';
import {CovanceFileUploadModule} from '../covance-file-upload/covance-file-upload.module';
import {EQueryDetailsStorage} from './e-query-details/e-query-details-storage';
import {EQueryCCQuestionComponent} from './e-query-details/e-query-cc-question/e-query-c-c-question.component';
import {OpenQuestionsComponent} from './e-query-details/open-questions/open-questions.component';
import {EQueryCCQuestionResponseComponent} from './e-query-details/e-query-cc-question-response/e-query-c-c-question-response.component';
import { EQueryCommentsComponent } from './e-query-details/e-query-comments/e-query-comments.component';
import { EQueryAttachmentsListComponent } from './e-query-attachments-list/e-query-attachments-list.component';
import {ExternalUserEQueryContentBlockComponent} from './e-query-details/external-user-e-query-content-block/external-user-e-query-content-block.component';
import { AgePipe } from './accession-info/accession-age.pipe';
import { QuillModule } from 'ngx-quill';

@NgModule({
    imports: [
        SharedModule,
        UserModule,
        CovanceAgGridModule,
        GroupingModule,
        CovanceFilterModule,
        LegendModule,
        CommonModule,
        SimpleTextFieldModule,
        ReactiveFormsModule,
        CovanceDatePickerModule,
        CovanceFileUploadModule,
        QuillModule
    ],
    declarations: [
        ExternalUserEQueriesGridComponent,
        EQueriesFreeTextQuestionComponent,
        EQueryAccessionInfoComponent,
        EQueryAttachmentsComponent,
        EQueryDetailsTextFieldComponent,
        EQueryCCQuestionComponent,
        OpenQuestionsComponent,
        EQueryCCQuestionResponseComponent,
        EQueryCommentsComponent,
        EQueryAttachmentsListComponent,
        ExternalUserEQueryContentBlockComponent,
        AgePipe
    ],
    entryComponents: [
    ],
    providers: [
        EQueryFilterDefinitions,
        EQueriesColumns,
        ReadEQueryEmitter,
        ExternalUserEQueriesColumns,        
        ExternalUserEQueriesFilterDefinitions,
        ExternalUserEQueriesGridDefaultSort,
        EQueryAttachmentsDownloader,
        EQueryDetailsStorage
    ],
    exports: [
        ExternalUserEQueriesGridComponent,
        EQueriesFreeTextQuestionComponent,
        EQueryAccessionInfoComponent,
        EQueryAttachmentsComponent,
        EQueryDetailsTextFieldComponent,
        EQueryCCQuestionComponent,
        OpenQuestionsComponent,
        EQueryCCQuestionResponseComponent,
        EQueryCommentsComponent,
        ExternalUserEQueryContentBlockComponent,
        EQueryAttachmentsListComponent,
    ]
})
export class EQueriesModule {
}
